"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Shop() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    label: "N° 120 COLLECTIONS",
    align: "left"
  }, {
    label: "N° 45 DESIGNERS",
    align: "right"
  }, {
    label: "CURATED DAILY",
    align: "left"
  }];
  const tickerItems = ["PREMIUM QUALITY", "GLOBAL SHIPPING", "SECURE", "LUSH-GUARANTEE", "PREMIUM QUALITY", "GLOBAL SHIPPING", "SECURE", "LUSH-GUARANTEE", "PREMIUM QUALITY", "GLOBAL SHIPPING", "SECURE", "LUSH-GUARANTEE"];
  return <section data-section-id="2194" id="shop-title" ref={sectionRef} className="relative overflow-hidden bg-background py-32 md:py-44">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-start justify-end overflow-hidden">
        <span className="font-default font-light leading-none select-none translate-x-[8%] -translate-y-[10%]" style={{
        fontSize: "clamp(14rem, 22vw, 22rem)",
        fontWeight: 200,
        color: "hsl(240 10% 4% / 0.04)"
      }}>
          01
        </span>
      </div>

      <div className="relative mx-auto max-w-[1440px] px-[clamp(1.25rem,4vw,4.5rem)]">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-6">
          {}
          <div className="md:col-span-8">
            {}
            <div className={`flex items-center gap-4 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`} style={{
            transitionDelay: "0ms"
          }}>
              <span className="block h-px w-6 bg-border" />
              <span className="font-mono text-[0.6875rem] sm:text-[0.75rem] md:text-[0.8125rem] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                § N° 01 — The Editorial Shop
              </span>
            </div>

            {}
            <h1 className={`mt-8 font-default text-foreground transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`} style={{
            fontSize: "clamp(2.75rem, 6.5vw, 6.25rem)",
            fontWeight: 900,
            lineHeight: 0.9,
            letterSpacing: "-0.04em",
            transitionDelay: "80ms"
          }}>
              The complete{" "}
              <span className="relative inline-block">
                <em className={`font-default italic transition-opacity duration-200 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
                transitionDelay: "280ms"
              }}>
                  collection
                </em>
                {}
                <span aria-hidden="true" className="absolute -bottom-1 left-0 flex items-center" style={{
                width: "100%"
              }}>
                  <span className="block h-px bg-accent transition-all ease-out" style={{
                  width: isVisible ? "100%" : "0%",
                  transitionDelay: "760ms",
                  transitionDuration: "480ms"
                }} />
                  <span className={`ml-[-3px] block h-[6px] w-[6px] rounded-lg bg-accent transition-opacity duration-200 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
                  transitionDelay: "1240ms"
                }} />
                </span>
              </span>
              .
            </h1>

            {}
            <p className={`mt-10 max-w-[640px] font-default text-muted-foreground transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`} style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
            fontWeight: 400,
            lineHeight: 1.6,
            transitionDelay: "240ms"
          }}>
              An avant-garde selection of high-street essentials, luxury garments, and curated accessories — each piece hand-picked, each style verified, each ready to define your aesthetic.
            </p>
          </div>

          {}
          <div className="md:col-span-4 md:pt-4">
            <div className="flex flex-col">
              {stats.map((stat, i) => <div data-index={i} key={i} className={`group relative py-6 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`} style={{
              transitionDelay: `${320 + i * 80}ms`
            }}>
                  {}
                  <div aria-hidden="true" className={`absolute top-0 left-0 right-0 flex items-center ${stat.align === "right" ? "flex-row-reverse" : "flex-row"}`}>
                    <span className="block h-[6px] w-[6px] rounded-lg bg-accent" />
                    <span className="block h-px flex-1 bg-border" />
                  </div>

                  <span className="font-mono text-[0.8125rem] font-medium uppercase tracking-[0.18em] text-foreground">
                    {stat.label}
                  </span>
                </div>)}
              {}
              <div aria-hidden="true" className="flex items-center flex-row-reverse">
                <span className="block h-[6px] w-[6px] rounded-lg bg-accent" />
                <span className="block h-px flex-1 bg-border" />
              </div>
            </div>
          </div>
        </div>

        {}
        <div className={`mt-20 md:mt-28 overflow-hidden border-t border-border pt-8 transition-opacity duration-700 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
        transitionDelay: "560ms"
      }}>
          <div className="ticker-track flex whitespace-nowrap">
            {[...tickerItems, ...tickerItems].map((item, i) => <span data-index={i} key={i} className="font-mono text-[0.8125rem] font-medium uppercase tracking-[0.18em] text-muted-foreground flex items-center">
                <span className="mx-6">{item}</span>
                <span className="text-accent">•</span>
              </span>)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .ticker-track {
          animation: ticker-scroll 60s linear infinite;
          width: max-content;
        }
      `}</style>
    </section>;
}